export const ArmorTokenEvents = {
  // GetToken: 'Boilerplate.GetToken',
  // TokenReturned: 'Boilerplate.TokenReturned',
}
